// extracted by mini-css-extract-plugin
module.exports = {"root":"Stepper_root__1v1o3","stepper":"Stepper_stepper__34axb","stepper--custom":"Stepper_stepper--custom__1wIqV","stepper--limitedAccess":"Stepper_stepper--limitedAccess__2q0YH"};